import React, {useCallback, useEffect, useState} from 'react'
import {useNavigate} from 'react-router-dom'
import {http} from '../../../../../shared/http'
import {inviteCode} from './invite-code'
import {useSharedStore} from '../../../../../state/shared-store-context'
import {getApiErrorMessage} from '../../../../../shared/api-errors'

export const AppleCallback = () => {
    const navigate = useNavigate()
    const {actions} = useSharedStore()
    const [error, setError] = useState(null)
    const [isProcessing, setIsProcessing] = useState(true)

    const handleAppleCallback = useCallback(async (code) => {
        try {
            const response = await http.post('/api/v1/auth/apple/callback', {
                code,
                redirectUri: window.location.origin + '/auth/apple/callback',
                inviteCode: inviteCode.get(),
            })

            if (response.data.user) {
                actions.setSessionUser(response.data.user)
                navigate('/following/map', {replace: true, state: null})
            } else {
                throw new Error('No user received')
            }
        } catch (error) {
            console.error('Apple auth error:', error)
            setError(getApiErrorMessage(error, 'Authentication failed. Please try again.'))
            setIsProcessing(false)
            setTimeout(() => navigate('/auth'), 3000)
        }
    }, [actions, navigate])

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search)
        const code = urlParams.get('code')
        const errorParam = urlParams.get('error')

        if (errorParam) {
            setError('Authentication cancelled or failed')
            setIsProcessing(false)
            setTimeout(() => navigate('/auth'), 3000)
            return
        }

        if (!code) {
            setError('No authorization code received')
            setIsProcessing(false)
            setTimeout(() => navigate('/auth'), 3000)
            return
        }

        handleAppleCallback(code)
    }, [navigate, handleAppleCallback])

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '100vh',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            color: 'white',
            padding: '20px'
        }}>
            {isProcessing ? (
                <>
                    <div style={{
                        width: '48px',
                        height: '48px',
                        border: '4px solid rgba(255,255,255,0.3)',
                        borderTopColor: 'white',
                        borderRadius: '50%',
                        animation: 'spin 1s linear infinite',
                        marginBottom: '20px'
                    }}></div>
                    <h2 style={{margin: 0, fontSize: '24px'}}>Authenticating with Apple...</h2>
                </>
            ) : (
                <>
                    <div style={{
                        fontSize: '48px',
                        marginBottom: '20px'
                    }}>❌</div>
                    <h2 style={{margin: '0 0 10px 0', fontSize: '24px'}}>{error}</h2>
                    <p style={{margin: 0, opacity: 0.9}}>Redirecting to login...</p>
                </>
            )}
            <style>{`
                @keyframes spin {
                    to { transform: rotate(360deg); }
                }
            `}</style>
        </div>
    )
}
